import React from "react";

// Vimeo-Link (vimeo.com/<id>[/<hash>] oder player.vimeo.com/...) als responsiver Player.
const toPlayerUrl = (url) => {
  const u = String(url || "").trim();
  if (!u) return "";
  if (u.includes("player.vimeo.com")) return u;
  const m = u.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-z0-9]+))?/i);
  if (!m) return "";
  return `https://player.vimeo.com/video/${m[1]}${m[2] ? `?h=${m[2]}` : ""}`;
};

export const VimeoEmbed = ({ url, title = "Video", testId = "vimeo-embed" }) => {
  const src = toPlayerUrl(url);
  if (!src) return null;
  return (
    <div className="relative w-full overflow-hidden rounded-xl bg-black" style={{ paddingTop: "56.25%" }} data-testid={testId}>
      <iframe
        src={src}
        title={title}
        className="absolute inset-0 w-full h-full"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default VimeoEmbed;
